import uintToMimeType from './uintToMimeType';

// ----------------------------------------------------------------------------

function arrayBufferToMimeType(arrayBuffer: ArrayBuffer): string {
    const uint = new Uint8Array(arrayBuffer);

    const type = uintToMimeType(uint);

    return type;
}

// ----------------------------------------------------------------------------

export default arrayBufferToMimeType;
